export default __webpack_public_path__ + "static/media/systemowe8.c26a437a.jpg";